import styled from 'styled-components'

export const DottedLine = styled.div`
  border: none;
  margin-top: 20px;
  margin-bottom: 20px;
  border-top: 2px dotted #c7c9c7;
  color: #fff;
  background-color: #fff;
  height: 2px;
  width: 100%;
`
